import { render, staticRenderFns } from "./AddAffiliateCodeComponent.vue?vue&type=template&id=4c6622da"
import script from "./AddAffiliateCodeComponent.vue?vue&type=script&lang=js"
export * from "./AddAffiliateCodeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports